import { CustomerErrorDetailsDtoCodeEnum } from '@/api/generated';

/** A customer that is not ACTIVE cannot become the customer of a process (creation or change of the customer). */
export const PROCESS_CUSTOMER_ERROR_CODES: readonly CustomerErrorDetailsDtoCodeEnum[] = [
  CustomerErrorDetailsDtoCodeEnum.CustomerNotApproved,
];
